import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', canvasWidth }) {
  //var animation=gsap.to(sprite, {rotation:"+=1", duration: (duration*speed),ease: "steps(40)", paused:true,yoyo:true, transformOrigin:"50% 50%" });
  var animation = gsap.to(sprite, 1, { pixi: {} });
  return animation;
}
export default { Animate };

// import { gsap } from "gsap";
// function Animate(sprite,  { duration= 1,speed=1, ease= 'Cubic.easeIn',canvasWidth }) {
//     var finalx= sprite.x;
//     sprite.x =  -(canvasWidth-sprite.x);
//     var animation=gsap.to(sprite, { x: finalx, duration: (duration*speed),ease: "steps(40)", paused:true });
//     return animation;
// }
// export default { Animate };
